import { getCurrentInstance } from 'vue'

export function useGlobalProperties () {
  const vm = getCurrentInstance()

  return vm.appContext.config.globalProperties
}
